<template>
  <div class="home">
    <!-- header -->
    <div class="container p-0">
      <img src="@/assets/img/header-income.png" alt="header" width="100%">
    </div>
    <!-- header -->
    <!-- body -->
    <div class="container">
      <div class="row bg_ffffff">
        <div class="col-12 col-sm-12 padding_30 paddings_top_0">
          <div class="csfont_Signika_Lite color_6d6e71 text-left font-size-16">
            <form @submit.prevent="Submit" v-if="!viewNone">
              <div class="row px-3">
                <!-- *************************************************** -->
                <div class="col-6 col-sm-8"></div>
                <!-- *************************************************** -->
                <div class="col-6 col-sm-4">
                  <span class="pl-2">วันที่:</span>
                  <input
                    type="date"
                    class="ml-1 w-100"
                    id="date"
                    v-model="IncomeCertificate.Profile.date"
                    @change="DateStyleText"
                    :class="DateSelect == true ? 'text-sec' : ''"
                    required
                    style="padding-left: 10px; padding: 2.5px"
                  />
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12 mt-2">
                  <h4 class="text-dark">ข้าพเจ้า</h4>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12">
                  <div class="row">
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6">
                      <span class="pl-2">ชื่อ-สกุล:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.Name"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6">
                      <span class="pl-2">ตำแหน่ง:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.Positions"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">สถานที่ทำงาน:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.Workplace"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">เลขที่:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.Number"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-5 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">หมู่ที่:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.Moo"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-7 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ตรอก/ซอย:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                         v-model="IncomeCertificate.Profile.Soi"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ถนน:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.Road"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ตำบล/แขวง:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                           v-model="IncomeCertificate.Profile.Tambon"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">อำเภอ/เขต:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.District"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">จังหวัด:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.Province"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">รหัสไปรษณีย์:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.Postcode"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">โทรศัพท์:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Profile.Mobile"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                  </div>
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12 mt-5">
                  <h4 class="text-dark">ขอรับรองว่า</h4>
                </div>
                <div class="col-12 col-sm-12 mt-1">
                  <h5>&emsp;ข้อมูลบิดา</h5>
                  <hr class="mt-1" />
                </div>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12">
                  <div class="row">
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6">
                      <span class="pl-2">นาย:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Name"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6">
                      <span class="pl-2">อายุ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Age"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">สถานภาพ-บิดา:</span>
                      <br />
                      <select
                        style="padding: 4px; margin-left: 5px"
                        class="w-100 ml-1"
                        :class="FatherAliveSelect == true ? 'text-sec' : ''"
                        required
                        v-model="IncomeCertificate.Father.Alive.Status"
                      >
                        <option selected disabled :value="null">---</option>
                        <option :value="1">มีชิวิต</option>
                        <option :value="0">เสียชีวิต</option>
                      </select>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1" :class="
                          IncomeCertificate.Father.Alive.Status == 0
                            ? ''
                            : 'd-none'
                        ">
                      <span class="pl-2">ปีที่เสียชีวิต:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        :disabled="
                          IncomeCertificate.Father.Alive.Status == 0
                            ? false
                            : true
                        "
                        placeholder="---"
                        v-model="IncomeCertificate.Father.Alive.Year"
                        required
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">บิดาของ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                          v-model="IncomeCertificate.Father.FatherOfName"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ประกอบอาชีพ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        placeholder="---"
                        v-model="IncomeCertificate.Father.Occupation"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">สถานที่ทำงาน:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Workplace"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-6 col-sm-4 col-md-6 mt-1">
                      <span class="pl-2">เลขที่:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Number"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-6 col-sm-8 col-md-6 mt-1">
                      <span class="pl-2">หมู่ที่:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Moo"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ตรอก/ซอย:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Soi"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ถนน:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Road"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ตำบล/แขวง:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Tambon"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">อำเภอ/เขต:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.District"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">จังหวัด:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Province"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">รหัสไปรษณีย์:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Postcode"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">โทรศัพท์:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Phone"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">มีรายได้ปีละ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Father.Income"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                  </div>
                </div>
                <div class="col-12 col-sm-12 mt-4">
                  <h5>&emsp;ข้อมูลมารดา</h5>
                  <hr class="mt-1" />
                </div>
                <div class="col-12 col-sm-12">
                  <div class="row">
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6">
                      <span class="pl-2">นาง/นางสาว:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Name"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6">
                      <span class="pl-2">อายุ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Age"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">สถานภาพ-มารดา:</span>
                      <br />
                      <select
                        style="padding: 4px; margin-left: 5px"
                        class="w-100 ml-1"
                        :class="MotherAliveSelect == true ? 'text-sec' : ''"
                        required
                        v-model="IncomeCertificate.Mother.Alive.Status"
                      >
                        <option selected disabled :value="null">---</option>
                        <option :value="1">มีชิวิต</option>
                        <option :value="0">เสียชีวิต</option>
                      </select>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1" :class="
                          IncomeCertificate.Mother.Alive.Status == 0
                            ? ''
                            : 'd-none'
                        ">
                      <span class="pl-2">ปีที่เสียชีวิต:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        :disabled="
                          IncomeCertificate.Mother.Alive.Status == 0
                            ? false
                            : true
                        "
                        v-model="IncomeCertificate.Mother.Alive.Year"
                        placeholder="---"
                        required
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">มารดาของ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.MotherOfName"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ประกอบอาชีพ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Occupation"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">สถานที่ทำงาน:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                          v-model="IncomeCertificate.Mother.Workplace"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-6 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">เลขที่:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Number"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-6 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">หมู่ที่:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Moo"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ตรอก/ซอย:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Soi"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ถนน:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Road"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ตำบล/แขวง:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Tambon"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">อำเภอ/เขต:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.District"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">จังหวัด:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Province"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">รหัสไปรษณีย์:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Postcode"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">โทรศัพท์:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Phone"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">มีรายได้ปีละ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.Mother.Income"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                  </div>
                </div>
                <div class="col-12 col-sm-12 mt-4">
                  <h5>&emsp;กรณีผู้ปกครอง(ไม่ใช่บิดา–มารดา)</h5>
                  <hr class="mt-1" />
                </div>
                <div class="col-12 col-sm-12">
                  <div class="row">
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6">
                      <span class="pl-2">ชื่อ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.NotMotherFather.Name"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ผู้ปกครองของ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.NotMotherFather.ScholarshipApplicantName"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ประกอบอาชีพ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.NotMotherFather.Occupation"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">สถานที่ทำงาน:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.NotMotherFather.Workplace"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-6 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">เลขที่:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
v-model="IncomeCertificate.NotMotherFather.Number"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-6 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">หมู่ที่:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
v-model="IncomeCertificate.NotMotherFather.Moo"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ตรอก/ซอย:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
v-model="IncomeCertificate.NotMotherFather.Soi"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ถนน:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.NotMotherFather.Road"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">ตำบล/แขวง:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.NotMotherFather.Tambon"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">อำเภอ/เขต:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                         v-model="IncomeCertificate.NotMotherFather.District"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">จังหวัด:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                         v-model="IncomeCertificate.NotMotherFather.Province"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">รหัสไปรษณีย์:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.NotMotherFather.Postcode"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">โทรศัพท์:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                         v-model="IncomeCertificate.NotMotherFather.Phone"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-6 col-md-6 mt-1">
                      <span class="pl-2">มีรายได้ปีละ:</span>
                      <input
                        type="text"
                        class="ml-1 w-100"
                        required
                        v-model="IncomeCertificate.NotMotherFather.Income"
                        placeholder="---"
                        style="padding-left: 10px; padding: 2.5px"
                      />
                    </div>
                    <!-- *************************************************** -->
                  </div>
                </div>
                <div class="col-12 col-sm-12 mt-2">
                  <div class="row pl-2">
                    <div class="col-2 col-sm-1 mt-4 p-0">
                      <center>
                        &emsp;
                        <input class="form-check-input" type="checkbox" required v-model="IncomeCertificate.Approved"/>
                      </center>
                    </div>
                    <div class="col-10 col-sm-11 mt-4 p-0">
                      <p class="form-check-label">
                        ข้าพเจ้าขอรับรองและยืนยันว่าข้อความดังกล่าวข้างต้นเป็นความจริง
                        หากปรากฎภายหลังว่าได้มีการรับรองข้อความ อันเป็นเท็จ
                        ข้าพเจ้ายินยอมรับผิดชอบต่อความเสียหายที่อาจเกิดขึ้น
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12" id="Signature">
                  <div class="row">
                    <div class="col-12 col-sm-8 mt-3">
                      <div class="row mt-2">
                        <div class="col-12 col-sm-6 col-md-6">
                          <span> อาจารย์ที่ปรึกษา: </span>
                          <input
                            type="text"
                            class="ml-1 w-100 mb-1"
                            placeholder="---"
                            required
                            v-model="IncomeCertificate.Signature.Name"
                            style="padding-left: 10px"
                          />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6">
                          <span> ตำแหน่ง: </span>
                          <input
                            type="text"
                            class="ml-1 w-100 mb-1"
                            placeholder="---"
                            required
                            v-model="IncomeCertificate.Signature.Positions"
                            style="padding-left: 10px"
                          />
                        </div>

                        <div class="col-12 col-sm-4 col-md-4 mt-3">
                          <label
                            for="AuthorisedSignatureUpload"
                            class="custom-file-upload btn btn-app ml-2"
                          >
                            ลายเซ็น
                          </label>
                        </div>
                        <div class="col-12 col-md-8 text-truncate mt-3 ml-2">
                          {{IncomeCertificate.Signature.SignatureImageOldName}}
                        </div>
                        <input
                          id="AuthorisedSignatureUpload"
                          type="file"
                          @change="FileSignature"
                          accept="image/*"
                        />
                      </div>
                    </div>
                    <!-- *************************************************** -->
                    <div class="col-12 col-sm-4 mt-3">
                      <img
                        :src="FileUploadURL"
                        alt="placeholder"
                        class="img-cover"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 mt-4 border border-dark">
                  <div class="row">
                    <p class="text-underline mb-0 text-dark">หมายเหตุ</p>
                    <p class="mb-1">1. การรับรองรายได้ของครอบครัว ให้บุคคลดังต่อไปนี้เป็นผู้รับรองและแนบสำเนาบัตรพร้อมลงชื่อรับรองสำเนาด้วย
                      <ul style="list-style: none" class="mb-1">
                        <li>1.1 ข้าราชการผู้ดำรงตำแหน่งระดับ 5 ขึ้นไป หรือ ตำแหน่งเทียบเท่า หรือ </li>
                        <li>1.2 ผู้บริหารสถาบันการศึกษา หรือ </li>
                        <li>1.3 ผู้ปกครองท้องถิ่นระดับผู้ใหญ่บ้านขึ้นไป (ไม่รับพิจารณาผู้รับรองที่นอกเหนือจากที่กำหนด)</li>
                      </ul>
                      <!-- 2. ผู้รับรองรายได้ต้องเขียนข้อความด้วยลายมือตนเองทั้งฉบับ ไม่มีการขูด ลบ ขีด ฆ่า หากเขียนผิด ต้องมีลายเซ็นผู้รับรองรายได้เซ็นกำกับ ห้ามใช้น้ำยาลบคำผิด -->
                    </p>
                  </div>
                </div>
              </div>
              <center>
                <a
                  v-if="preview"
                  class="btn btn-app mt-5 align-center mx-1"
                  @click="EditeScholarship"
                >
                  <div>ย้อนกลับ</div>
                </a>
                <button
                  v-if="preview"
                  type="submit"
                  class="btn btn-app mt-5 align-center mx-1"
                >
                  <div>ต่อไป</div>
                </button>
              </center>
              <br />
            </form>
            <div class="row" v-else>
                <!-- *************************************************** -->
                <div class="col-12 col-sm-12 my-1">
                  <p class="pl-2" align="right">วันที่: {{IncomeCertificate.Profile.date}}</p>
                </div>
                <div class="col-12 mt-2 px-4">
                  <p align="justify">&emsp;&emsp;
                    ข้าพเจ้า {{IncomeCertificate.Profile.Name}} 
                    ตำแหน่ง {{IncomeCertificate.Profile.Positions}} 
                    สถานที่ทำงาน {{IncomeCertificate.Profile.Workplace}}
                    เลขที่ {{IncomeCertificate.Profile.Number}}
                    หมู่ที่ {{IncomeCertificate.Profile.Moo}}
                    ตรอก/ซอย {{IncomeCertificate.Profile.Soi}}
                    ถนน {{IncomeCertificate.Profile.Road}}
                    ตำบล/แขวง {{IncomeCertificate.Profile.Tambon}}
                    อำเภอ/เขต {{IncomeCertificate.Profile.District}}
                    จังหวัด {{IncomeCertificate.Profile.Province}}
                    รหัสไปรษณีย์ {{IncomeCertificate.Profile.Postcode}}
                    โทรศัพท์ {{IncomeCertificate.Profile.Mobile}}
                  </p>
                  <p align="justify">&emsp;&emsp;
                    ขอรับรองว่า นาย {{IncomeCertificate.Father.Name}} 
                    อายุ {{IncomeCertificate.Father.Age}} 
                    <span :class="IncomeCertificate.Father.Alive.Status == 0? '':'d-none'">สถานภาพ เสียชีวิต เมื่อปี  {{IncomeCertificate.Father.Alive.Year}}</span>
                    บิดาของ {{IncomeCertificate.Father.FatherOfName}}
                    ประกอบอาชีพ {{IncomeCertificate.Father.Occupation}}
                    สถานที่ทำงาน {{IncomeCertificate.Father.Workplace}}
                    เลขที่ {{IncomeCertificate.Father.Number}} 
                    หมู่ที่ {{IncomeCertificate.Father.Moo}}
                    ตรอก/ซอย {{IncomeCertificate.Father.Soi}},
                    ถนน {{IncomeCertificate.Father.Road}},
                    ตำบล/แขวง {{IncomeCertificate.Father.Tambon}},
                    อำเภอ/เขต {{IncomeCertificate.Father.District}},
                    จังหวัด {{IncomeCertificate.Father.Province}} 
                    รหัสไปรษณีย์ {{IncomeCertificate.Father.Postcode}}
                    โทรศัพท์ {{IncomeCertificate.Father.Phone}}
                    มีรายได้ปีละ {{IncomeCertificate.Father.Income}}
                  </p>
                  <p align="justify">&emsp;&emsp;
                    ขอรับรองว่า นาง {{IncomeCertificate.Mother.Name}} 
                    อายุ {{IncomeCertificate.Mother.Age}} 
                    <span :class="IncomeCertificate.Mother.Alive.Status == 0? '':'d-none'">สถานภาพ เสียชีวิต เมื่อปี  {{IncomeCertificate.Father.Alive.Year}}</span>
                    มารดาของ {{IncomeCertificate.Mother.FatherOfName}}
                    ประกอบอาชีพ {{IncomeCertificate.Mother.Occupation}}
                    สถานที่ทำงาน {{IncomeCertificate.Mother.Workplace}}
                    เลขที่ {{IncomeCertificate.Mother.Number}} 
                    หมู่ที่ {{IncomeCertificate.Mother.Moo}}
                    ตรอก/ซอย {{IncomeCertificate.Mother.Soi}},
                    ถนน {{IncomeCertificate.Mother.Road}},
                    ตำบล/แขวง {{IncomeCertificate.Mother.Tambon}},
                    อำเภอ/เขต {{IncomeCertificate.Mother.District}},
                    จังหวัด {{IncomeCertificate.Mother.Province}} 
                    รหัสไปรษณีย์ {{IncomeCertificate.Mother.Postcode}}
                    โทรศัพท์ {{IncomeCertificate.Mother.Phone}}
                    มีรายได้ปีละ {{IncomeCertificate.Mother.Income}}
                  </p>
                  <p align="justify">&emsp;&emsp;
                    กรณีผู้ปกครอง(ไม่ใช่บิดา–มารดา) {{IncomeCertificate.NotMotherFather.Name}} 
                    ผู้ปกครองของ {{IncomeCertificate.NotMotherFather.FatherOfName}}
                    ประกอบอาชีพ {{IncomeCertificate.NotMotherFather.Occupation}}
                    สถานที่ทำงาน {{IncomeCertificate.NotMotherFather.Workplace}}
                    เลขที่ {{IncomeCertificate.NotMotherFather.Number}} 
                    หมู่ที่ {{IncomeCertificate.NotMotherFather.Moo}}
                    ตรอก/ซอย {{IncomeCertificate.NotMotherFather.Soi}},
                    ถนน {{IncomeCertificate.NotMotherFather.Road}},
                    ตำบล/แขวง {{IncomeCertificate.NotMotherFather.Tambon}},
                    อำเภอ/เขต {{IncomeCertificate.NotMotherFather.District}},
                    จังหวัด {{IncomeCertificate.NotMotherFather.Province}} 
                    รหัสไปรษณีย์ {{IncomeCertificate.NotMotherFather.Postcode}}
                    โทรศัพท์ {{IncomeCertificate.NotMotherFather.Phone}}
                    มีรายได้ปีละ {{IncomeCertificate.NotMotherFather.Income}}
                  </p>
                  <p align="justify">&emsp;&emsp;ข้าพเจ้าขอรรับรองและยืนยันว่าข้อความดังกล่าวข้างต้นเป็นความจริง หากปรากฎภายหลังว่าได้มีการรับรองข้อความอันเป็นเท็จ ข้าพเจ้ายินยอมรับผิดชอบต่อความเสียหายที่อาจเกิดขึ้น
                  </p>
                </div>
                <div class="col-12 col-sm-6 col-md-7 mt-2 text-dark">
                </div>
                <div class="col-12 col-sm-6 col-md-5 mt-2 text-dark">
                  <p align="right" class="mb-0">ลงชื่อ: <img
                        :src="FileUploadURL"
                        alt="placeholder"
                        class="img-cover w-50"
                      />
                  </p>
                  <p align="right" class="mb-0">( {{IncomeCertificate.Signature.Name}} )&ensp;</p>
                  <p align="right" class="mb-0">ตำแหน่ง {{IncomeCertificate.Signature.Positions}}&ensp;</p>
                </div>
                <div class="col-12 col-sm-12 col-md-12 mt-4 px-4">
                  <div class="row  border border-dark">
                    <p class="text-underline mb-0 text-dark">หมายเหตุ</p>
                    <p class="mb-1">1. การรับรองรายได้ของครอบครัว ให้บุคคลดังต่อไปนี้เป็นผู้รับรองละแนบสำเนาบัตรพร้อมลงชื่อรับรองสำเนาด้วย
                      <ul style="list-style: none" class="mb-1">
                        <li>1.1 ข้าราชการผู้ดำรงตำแหน่งระดับ 5 ขึ้นไป หรือ ตำแหน่งเทียบเท่า หรือ </li>
                        <li>1.2 ผู้บริหารสถาบันการศึกษา หรือ </li>
                        <li>1.3 ผู้ปกครองท้องถิ่นระดับผู้ใหญ่บ้านขึ้นไป (ไม่รับพิจารณาผู้รับรองที่นอกเหนือจากที่กำหนด)</li>
                      </ul>
                    </p>
                  </div>
                </div>
              <div class="col-12 col-sm-12 col-md-12 text-center">
                <button
                  v-if="edit"
                  :disabled="display"
                  class="btn btn-app mt-5 align-center mx-1"
                  @click="editeForm()"
                >
                  <div>&ensp;แก้ไข&ensp;</div>
                </button>
                <a
                  v-if="submit"
                  class="btn btn-app mt-5 align-center mx-1 "
                  @click="submitForm()"
                >
                  <div v-if="!display">ต่อไป</div>
                  <div class="loader m-tb-4" v-if="display">Loading...</div>
                </a>
             </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- body -->
    <!-- footer -->
    <div class="container p-0">
      <img src="@/assets/img/footer.png" alt="header" width="100%">
    </div>
    <!-- footer -->
  </div>
</template>

<script>
// CSS
import "@/assets/bootstrap/bootstrap.min.css";
import "@/assets/bootstrap/animate.css";
import "@/assets/bootstrap/fontface.css";
import "@/assets/css/font.css";
import "@/assets/bootstrap/custom.css";
import "@/assets/css/spacing.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

// Component
import { store } from "@/store";
import axios from "axios";

export default {
  name: "Home",
  store,
  components: {},
  data() {
    return {
      display: false,
      RandomID: null,
      preview: true,
      edit: false,
      submit: false,
      viewNone: false,
      IncomeCertificate: {
        Profile: {
          Date: "",
          Name: "",
          Positions: "",
          Workplace: "",
          Number: "",
          Moo: "",
          Soi: "",
          Road: "",
          Tambon: "",
          District: "",
          Province: "",
          Postcode: "",
          Phone: "",
          Mobile: "",
        },
        Father: {
          Name: "",
          Age: "",
          Alive: {
            Status: null,
            Year: "",
          },
          FatherOfName: "",
          Occupation: "",
          Workplace: "",
          Number: "",
          Moo: "",
          Soi: "",
          Road: "",
          Tambon: "",
          District: "",
          Province: "",
          Postcode: "",
          Phone: "",
          Income: "",
        },
        Mother: {
          Name: "",
          Age: "",
          Alive: {
            Status: null,
            Year: "",
          },
          MotherOfName: "",
          Occupation: "",
          Workplace: "",
          Number: "",
          Moo: "",
          Soi: "",
          Road: "",
          Tambon: "",
          District: "",
          Province: "",
          Postcode: "",
          Phone: "",
          Income: "",
        },
        NotMotherFather: {
          Name: "",
          Age: "",
          Alive: {
            Status: "",
            Year: "",
          },
          ScholarshipApplicantName: "",
          Occupation: "",
          Workplace: "",
          Number: "",
          Moo: "",
          Soi: "",
          Road: "",
          Tambon: "",
          District: "",
          Province: "",
          Postcode: "",
          Phone: "",
          Income: "",
        },
        Approved: "",
        Signature: {
          SignatureImage: "",
          SignatureImageOldName: "",
          Name: "",
          Positions: "",
        },
      },
      DateSelect: true,
      FatherAliveSelect: true,
      MotherAliveSelect: true,
      FileUpload: null,
      FileUploadURL: "https://via.placeholder.com/200?text=CPF",
      // BaseURLData: "http://localhost:8085/form/scholarship/",
      // BaseAPIData: "http://localhost:8083/",

      BaseURLData: "https://tica.or.th/uploads/form/scholarship-cpf/",
      BaseAPIData:
        "https://tica.or.th/uploads/form/scholarship-cpf/images/save/",
    };
  },
 async created(){
    sessionStorage.setItem("ScholarshipEdit",false);
    this.RandomID = await sessionStorage.getItem("UID");
  },
  mounted() {
    if(sessionStorage.getItem("IncomeEdit") == "true" &&sessionStorage.getItem("dataI2") != null){
      const editeData = sessionStorage.getItem("dataI2")
      this.IncomeCertificate = JSON.parse(editeData);
    this.FileUploadURL = this.IncomeCertificate.Signature.SignatureImage
    } 
    else {
    // this.IncomeCertificate.Profile = {
    //   date: "2022-05-23",
    //   Name: "ประสงค์ จงกระเบน",
    //   Positions: "อาจารย์ที่ปรึกษา",
    //   Workplace: "มหาวิทยาลัยศรีนครินทรวิโรฒ",
    //   Number: "114",
    //   Moo: "-",
    //   Soi: "สุขุมวิท 23",
    //   Road: "สุขุมวิท",
    //   Tambon: "คลองเตยเหนือ",
    //   District: "วัฒนา",
    //   Province: "กรุงเทพมหานคร ",
    //   Postcode: "10110",
    //   Phone: "044-000-0000",
    //   Mobile: "055-000-0000",
    // };
    // this.IncomeCertificate.Father = {
    //   Name: "สมชาย ทรงสิทธ์",
    //   Age: "45",
    //   Alive: {
    //     Status: 0,
    //     Year: "2560",
    //   },
    //   FatherOfName: "สมพง ทรงสิทธ",
    //   Occupation: "-",
    //   Workplace: "-",
    //   Number: "-",
    //   Moo: "-",
    //   Soi: "-",
    //   Road: "-",
    //   Tambon: "-",
    //   District: "-",
    //   Province: "-",
    //   Postcode: "-",
    //   Phone: "-",
    //   Income: "-",
    // };
    // this.IncomeCertificate.Mother = {
    //   Name: "สมศรี ทรงสิทธ์",
    //   Age: "40",
    //   Alive: {
    //     Status: 1,
    //     Year: "",
    //   },
    //   MotherOfName: "สมพง ทรงสิทธ",
    //   Occupation: "ธุรกิจส่วนตัว",
    //   Workplace: "สุขุมวิท",
    //   Number: "85/3",
    //   Moo: "-",
    //   Soi: "สุขุมวิท 12",
    //   Road: "สุขุมวิท",
    //   Tambon: "คลองเตย",
    //   District: "คลองเตย",
    //   Province: "กรุงเทพมหานคร",
    //   Postcode: "10260",
    //   Phone: "099-000-0000",
    //   Income: 260000,
    // };
    // (this.IncomeCertificate.NotMotherFather = {
    //   Name: "-",
    //   Age: "-",
    //   ScholarshipApplicantName: "-",
    //   Occupation: "-",
    //   Workplace: "-",
    //   Number: "-",
    //   Moo: "-",
    //   Soi: "-",
    //   Road: "-",
    //   Tambon: "-",
    //   District: "-",
    //   Province: "-",
    //   Postcode: "-",
    //   Phone: "-",
    //   Income: "-",
    // }),
    //   (this.IncomeCertificate.Approved = true);
    // this.IncomeCertificate.Signature = {
    //   SignatureImage: "",
    //   SignatureImageOldName: "",
    //   Name: "ประสงค์จงกระเบน",
    //   Positions: "อาจารย์ท่ีปรึกษา",
    // };
    }
  },
  methods: {
    Submit() {
      if (this.FileUpload == null && this.FileUploadURL == "https://via.placeholder.com/200?text=CPF") {
         alert('กรุณาอัปโหลด ลายเซ็น');
         document.getElementById('Signature').scrollIntoView();
      } else {
        this.previewForm();
      }
    },
    EditeScholarship(){
      this.$emit('IncomeFuncBack')
    },
    DateStyleText() {
      this.IncomeCertificate.Profile.date == ""
        ? (this.DateSelect = true)
        : (this.DateSelect = false);
    },
    FileSignature(evt) {
      evt.preventDefault();
      this.FileUpload = evt.target.files[0];
      this.FileUploadURL = URL.createObjectURL(this.FileUpload);
      this.IncomeCertificate.Signature.SignatureImageOldName =
        evt.target.files[0].name;
    },

    previewForm() {
      this.preview = !this.preview;
      this.edit = !this.edit;
      this.submit = !this.submit;
      this.viewNone = !this.viewNone;

    },
    editeForm() {
      this.preview = !this.preview;
      this.edit = !this.edit;
      this.submit = !this.submit;
      this.viewNone = !this.viewNone;
    },
    async submitForm() {
      if (this.display == false) {
        this.display = !this.display;
      }
      // Upload file
      if (sessionStorage.getItem("IncomeEdit") == "true" &&sessionStorage.getItem("dataI2") != null) {
        if (this.FileUpload != null) {
          this.IncomeCertificate.Signature.SignatureImage = await this.UploadFile(this.FileUpload,
          "signature",
          "incomeSignature");
        }
      } else {
         this.IncomeCertificate.Signature.SignatureImage = await this.UploadFile(this.FileUpload,
          "signature",
          "incomeSignature");
      }
      // set session
      await this.SetSession();
      // call func paren page
      await this.$emit("IncomeFunc");
    },
    async UploadFile(fileData, folder, Name) {
      var FileName = "";
      const UID = this.RandomID;
      const BaseURLData = this.BaseURLData;
      const BaseAPIData = this.BaseAPIData;
      const data = new FormData();
      data.append("fileUpload", fileData);
      data.append("fileName", Name);
      data.append("target", UID);
      data.append("subtarget", folder);
      //BaseURLData 
      const url = `${BaseAPIData}uploadFile.php`;
      const header = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      await axios.post(url, data, header).then(function (response) {
        FileName = `${BaseURLData}images/save/assets/img/${UID}/${folder}/${response.data.response}.${response.data.type}`;
      });
      return FileName;
    },
    async SetSession() {
      await sessionStorage.setItem(
        "dataI2",
        JSON.stringify(this.IncomeCertificate)
      );
    },
  },
};
</script>

<style scoped>
.btn-app-sec {
  color: #fff !important;
  background-color: rgba(128, 128, 128, 0.5) !important;
}
.btn-app-sec:hover {
  color: #fff !important;
  background-color: rgba(128, 128, 128, 0.4) !important;
}
.btn-app-sec:active {
  color: #fff !important;
  background-color: rgba(128, 128, 128, 0.5) !important;
}
.w-100 {
  width: 100% !important;
}
.bg_dark_blue {
  background-color: #102f50 !important;
}
.text-secondary {
  border-top: 1px solid #bfc6cc !important;
}
.catgory-input {
  position: absolute !important;
  right: 0 !important;
  padding-right: 5% !important;
}
.home {
  background-color: #3c3c3b !important;
  font-family: Georgia, Times, serif !important;
}
input[type="file"] {
  display: none !important;
}
.custom-file-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 5px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}

.custom-exam-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 5px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}
.btn-app {
  color: #fff !important;
  background-color: #102f51 !important;
}
.btn-app:hover {
  color: #fff !important;
  background-color: #235a99 !important;
}
.text-truncate {
  white-space: nowrap !important;
  padding-right: 5rem !important;
  padding-left: 1rem !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.w-45 {
  width: 45%;
}
.other-btn {
  padding: 6px 25px !important;
}
.text-sec {
  color: #6c757d !important;
}
</style>
<style>
.multiselect__option--highlight {
  background: #102f51 !important;
  outline: none !important;
  color: #fff !important;
}
.multiselect__option--highlight:after {
  background: #102f51 !important;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #102f51;
  margin-bottom: 0;
}
.multiselect__tags {
  min-height: 25px;
  padding: 2px 40px 0 8px;
  border-color: black;
}
.multiselect__tag-icon:after {
  color: white;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #102f51 !important;
}
.req {
  border-color: red !important;
}

.img-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.m-tb-4 {
  margin-top: 10.5px;
  margin-bottom: 10.5px;
}
</style>